module.exports = __webpack_public_path__ + "static/img/icon_announcement_bg.2f8ae0ac.png";